import React, { useEffect, useMemo, useState } from "react";
import { IconNotification } from "@arco-design/web-react/icon";
import { fetchConfigItem } from "@/services/config";
import styles from "./style/index.module.less";

const ANNOUNCEMENT_ITEM_CODE = "site_announcement";

const parseAnnouncementMessages = (value: any): string[] => {
  if (value === undefined || value === null) return [];
  if (Array.isArray(value)) {
    return value.map((entry) => String(entry ?? "").trim()).filter(Boolean);
  }
  const text = String(value).trim();
  if (!text) return [];
  try {
    const parsed = JSON.parse(text);
    if (Array.isArray(parsed)) {
      return parsed.map((entry) => String(entry ?? "").trim()).filter(Boolean);
    }
  } catch {
    // ignore JSON parse errors
  }
  return text
    .split(/\r?\n+/)
    .map((entry) => entry.trim())
    .filter(Boolean);
};

function AnnouncementBar() {
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    let mounted = true;
    fetchConfigItem(ANNOUNCEMENT_ITEM_CODE)
      .then((response) => {
        if (!mounted) {
          return;
        }
        if (!response || response.code !== 200) {
          setMessages([]);
          return;
        }
        const payload = response.data;
        const rawValue =
          payload && typeof payload === "object" && !Array.isArray(payload)
            ? payload.itemValue ??
              payload.defaultValue ??
              payload.paramConfig ??
              ""
            : payload ?? "";
        setMessages(parseAnnouncementMessages(rawValue));
      })
      .catch(() => {
        if (mounted) {
          setMessages([]);
        }
      });
    return () => {
      mounted = false;
    };
  }, []);

  const content = useMemo(() => messages.join("　　"), [messages]);

  if (!content) {
    return null;
  }

  return (
    <div className={styles.announcement}>
      <span className={styles["announcement-label"]}>
        <IconNotification />
        公告
      </span>
      <span className={styles["announcement-content"]}>{content}</span>
    </div>
  );
}

export default AnnouncementBar;
